import { ChevronsUpDown } from "lucide-react";
import type { Province } from "../utils/provinces";

type ProvinceSelectProps = {
  provinces: Province[];
  value?: string;
  onChange: (code: string) => void;
  placeholder: string;
  isInvalid?: boolean;
  className?: string;
  id?: string;
  "aria-describedby"?: string;
};

// A native select rather than a combobox like CountryCombobox: at most 60
// entries, and the mobile OS picker is what customers expect for a state.
export function ProvinceSelect({
  provinces,
  value,
  onChange,
  placeholder,
  isInvalid,
  className,
  id,
  "aria-describedby": ariaDescribedBy,
}: ProvinceSelectProps) {
  return (
    <div className={`relative ${className ?? ""}`}>
      <select
        id={id}
        aria-describedby={ariaDescribedBy}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={isInvalid}
        className={`min-h-[44px] w-full appearance-none rounded-md border border-input bg-background px-3 py-2 pr-9 text-sm transition-colors hover:bg-muted focus:outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive ${value ? "text-foreground" : "text-muted-foreground"}`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {provinces.map((province) => (
          <option key={province.code} value={province.code}>
            {province.name}
          </option>
        ))}
      </select>
      <ChevronsUpDown className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
}
